import { useMediaQuery, useTheme } from '@mui/material'


export const useIsMobile = () => {
  const theme = useTheme()
  // Check if ssr is enabled
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true })

  return isMobile
}